import { WebViewBridge } from 'common/webviewBridge';
import SupportedFeaturesInApp from 'common/webviewBridge/SupportedFeaturesInApp';

if (WebViewBridge.isClasstingRNWebView()) {
  document.addEventListener(
    'click',
    (event) => {
      for (
        let target: HTMLElement = event.target as HTMLElement;
        target && target !== this;
        target = target.parentNode as HTMLElement
      ) {
        if (target instanceof HTMLDocument) {
          break;
        }

        try {
          if (
            SupportedFeaturesInApp.enableDownloadUsingAnchor &&
            // lightgallery의 다운로드 버튼에서 target=_blank, download attribute를 사용하고 있음
            target?.matches('[target="_blank"][download]')
          ) {
            continue;
          }
          if (target?.matches('[target="_blank"]')) {
            const el = target as HTMLAnchorElement;

            WebViewBridge.open(el.href);

            event.preventDefault();
            break;
          }
        } catch (e) {
          console.error(e);
          continue;
        }
      }
    },
    false
  );

  window.open = (url) => {
    if (url) {
      WebViewBridge.open(url);
    }

    return null;
  };

  window.close = () => {
    WebViewBridge.close();
  };
}

export {};
